import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { UntypedFormBuilder, UntypedFormControl, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';

import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { GlobalsService } from '../../../services/globals.service';
import { PurchasingService } from '../../../services/purchasing.service';
import { PrintService } from '../../../services/print.service';
import { InventoryService } from '../../../services/inventory.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
	selector: 'app-purchasing-dailychurn',
	templateUrl: './purchasing-dailychurn.component.html',
	styleUrls: ['./purchasing-dailychurn.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		])
	]
})
export class PurchasingDailychurnComponent implements OnInit {
	@ViewChild('purchasedetails') purchasedetails: ElementRef;
	@ViewChild('itemhistoryele') itemhistoryele: ElementRef;
	@ViewChild('exportTable') exportTableRef: ElementRef;


	flip = 'inactive';
	locations: any = [];
	reportForm: UntypedFormGroup;
	today = new Date();
	results: any = [];
	loading = false;
	suppliers: any = [];
	purchase_item: any = [];
	foundvendors: any = [];
	itemhistory: any = false;
	item: any = false;
	purchitem: any = false;
	months: any = false;
	multiplier = new UntypedFormControl(60)
	rolling_months: any = false;
	loading_remote: any = false;
	filters: any = [];
	futuremonths: any = [];
	selected_filters: any = [];
	selected_checks: any = [];
	purchase_items: any = [];
	brands: any = [];
	po_vendors: any = [];
	remoteqtys: any = [];
	product_lines: any = [];
	allresults: any = [];
	po_vendors_found: any = false;
	wathchlist: any = [];
	indexnow = 1;
	sending = false;
	currentstep = 0;
	allitems: any = false;
	watch_items: any = false;
	retriving: any = false;
	reviewlabel = 'Review Primary Recommendations'
	config: any = [];
	user: any = false;
	lastCreatedPos: { orderno: string; supplierno: string }[] = [];
	poCreateError = '';
	/** Lines moved to RMA review (negative purchase qty), keyed by vendor index string */
	rmaReviewByVendor: Record<string, any[]> = {};
	winter_values: any = [{ 'label': 'Non Winter Tires', 'value': '0' }, { 'label': 'Winter Tires', 'value': '1' }, { 'label': '3-Peak All-Weather', 'value': '2' }];
	numberofdays: any = 0;
	constructor(private inventoryService: InventoryService, private purchasingService: PurchasingService, private globalSearchService: GlobalSearchService, private location: Location, private route: ActivatedRoute, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, private printService: PrintService) {

		this.config = this.globalsService.getApiConfig();
		this.globalSearchService.user.subscribe(results => {
			this.user = results
		});

	}

	getFilterString(): string {
		if (!this.reportForm) return '';
		const parts: string[] = [];
		const loccode = this.reportForm.get('loccode')?.value;
		if (loccode && this.locations?.length) {
			const loc = this.locations.find((l: any) => l.loccode === loccode);
			parts.push('Warehouse: ' + (loc ? loc.locationname : loccode));
		}
		if (this.po_vendors_found?.length) {
			parts.push('Vendor(s): ' + this.po_vendors_found.join(', '));
		} else {
			const sup = this.reportForm.get('supplier')?.value;
			if (sup) parts.push('Vendor: ' + sup);
		}
		const start = this.reportForm.get('startdate')?.value;
		const end = this.reportForm.get('enddate')?.value;
		if (start && end) {
			const s = typeof start === 'string' ? start : start?.toISOString?.()?.slice(0, 10) || start;
			const e = typeof end === 'string' ? end : end?.toISOString?.()?.slice(0, 10) || end;
			parts.push('Date range: ' + s + ' to ' + e);
		}
		const brands = this.reportForm.get('brands')?.value;
		if (Array.isArray(brands) && brands.length) parts.push('Brands: ' + brands.join(', '));
		const lines = this.reportForm.get('lines')?.value;
		if (Array.isArray(lines) && lines.length) {
			const lineLabels = lines.map((id: string) => {
				const pl = this.product_lines?.find((p: any) => p.line_field === id);
				return pl ? (pl.line_field + (pl.line_description ? ' - ' + pl.line_description : '')) : id;
			});
			parts.push('Product lines: ' + lineLabels.join('; '));
		}
		if (this.config?.env?.package === 'tires') {
			const season = this.reportForm.get('season')?.value;
			if (Array.isArray(season) && season.length && this.winter_values?.length) {
				const labels = season.map((v: string) => this.winter_values.find((w: any) => w.value === v)?.label || v);
				parts.push('Winter: ' + labels.join(', '));
			}
		}
		const min = this.reportForm.get('minimum_sales')?.value;
		if (min != null && min !== '') parts.push('Min orders: ' + min);
		const days = this.reportForm.get('days_supply')?.value;
		if (days != null && days !== '') parts.push('Day supply: ' + days);
		const skuText = this.reportForm.get('sku_list_text')?.value;
		const skuCount = this.parseSkuListFromText(skuText).length;
		if (skuCount > 0) parts.push('SKU list: ' + skuCount + ' item(s)');
		return parts.join(' | ');
	}

	/** Parses pasted text or CSV (first column per row when multiline). Deduped; server enforces max 5000. */
	parseSkuListFromText(text: string | null | undefined): string[] {
		if (text == null || !String(text).trim()) {
			return [];
		}
		const raw = String(text).replace(/^\uFEFF/, '');
		const out = new Set<string>();
		const pushCell = (c: string) => {
			const cell = c.replace(/^\s*"\s*|\s*"\s*$/g, '').trim();
			if (!cell) {
				return;
			}
			if (/^stockid$/i.test(cell) || /^sku$/i.test(cell) || /^item$/i.test(cell)) {
				return;
			}
			out.add(cell);
		};
		if (!/\r|\n/.test(raw)) {
			for (const part of raw.split(/[,;\t]+/)) {
				pushCell(part);
			}
			return Array.from(out);
		}
		const lines = raw.split(/\r?\n/);
		for (let line of lines) {
			line = line.trim();
			if (!line) {
				continue;
			}
			const cell = line.indexOf(',') >= 0 ? line.split(',')[0] : line;
			pushCell(cell);
		}
		return Array.from(out);
	}

	onSkuCsvFile(ev: Event) {
		const input = ev.target as HTMLInputElement;
		const file = input.files && input.files[0];
		if (!file) {
			return;
		}
		const reader = new FileReader();
		reader.onload = () => {
			const t = String(reader.result || '');
			this.reportForm.get('sku_list_text')?.setValue(t);
			input.value = '';
		};
		reader.readAsText(file);
	}

	clearSkuList() {
		this.reportForm.get('sku_list_text')?.setValue('');
	}

	ngOnInit(): void {
		this.purchasingService.getFiltersTwo().subscribe(async (result: any) => {
			this.filters = result;
		});

		this.purchasingService.getSuppliers('').subscribe((results: any) => {

			const today = new Date();
			const priorDate = new Date(new Date().setDate(today.getDate() - 365));

			this.numberofdays = this.datediff(today, priorDate);

			this.suppliers = results;
			this.reportForm = this.fb.group({
				startdate: [priorDate, Validators.required],
				enddate: [today, Validators.required],
				minimum_sales: [0, Validators.required],
				item_type: [1, Validators.required],
				numberofmonths: [2],
				numberofweeks: [8],
				loccode: [this.user.user.defaultlocation.loccode, Validators.required],
				filters: [],
				brands: [],
				season: [],
				lines: [],
				supplier: ['', Validators.required],
				days_supply: [60],
				sku_list_text: ['']
			});



			this.inventoryService.getBrands().subscribe((r: any) => {
				this.brands = r;

				const selected = [];
				this.brands.forEach(a => {
					selected.push(a.name)
				});
				this.reportForm.get('brands').setValue(selected)
			});

			this.inventoryService.getItemProductlines().subscribe((r: any) => {
				this.product_lines = r;

				const selected = [];
				// this.brands.forEach( a=> {
				// 	selected.push(a.name)
				// });
				// this.reportForm.get('brands').setValue(selected)
			});

			this.reportForm.markAllAsTouched();

			Object.keys(this.reportForm.controls).forEach(field => {
				const control = this.reportForm.get(field);
				if (control.invalid) {
					console.log(`Error in ${field}: `, control.errors);
				}
			});
		});
	}

	datediff(first, second) {
		return Math.round((second - first) / (1000 * 60 * 60 * 24));
	}

	updateTargets(value: any) {
		if (this.po_vendors_found && this.po_vendors_found.length) {
			this.po_vendors_found.forEach(v => {
				this.results[v].forEach(i => {
					i.target_avg_day = (i.avg_day * value) - i.actual_on_hand
				})
			})
		}
	}

	updateTargetsPullover() {
		if (this.po_vendors_found && this.po_vendors_found.length) {
			this.po_vendors_found.forEach(v => {
				this.results[v].forEach(i => {
					i.target_avg_day = (i.avg_day * this.reportForm.get('days_supply').value) - i.actual_on_hand
				})
			})
		}
	}

	updateProductLines() {
		const data = {
			brands: this.reportForm.get('brands').value
		}
		this.inventoryService.getBrandProductlines(data).subscribe((r: any) => {
			this.product_lines = r;

			const selected = [];
			this.product_lines.forEach(a => {
				selected.push(a.line_field)
			});
			this.reportForm.get('lines').setValue(selected)
		});
	}

	updateBrands(event: any) {
		this.reportForm.get('supplier').setValue(event.supplierid)
		const supplierid = event.supplierid;

		const defaultBrands = this.brands.filter(r => {
			const is_priority = r['priorities'].filter((opt) => {
				return opt.supplierno == supplierid;
			})
			return supplierid == r.a2 || is_priority.length
		})
		const selected = [];
		defaultBrands.forEach(a => {
			selected.push(a.name)
		})

		if (!selected.length) {
			// this.brands.forEach( a=> {
			// 	selected.push(a.name)
			// })
		}

		this.reportForm.get('brands').setValue(selected)


		const data = {
			supplier: event.supplierid
		}
		this.inventoryService.getBrandProductlines(data).subscribe((r: any) => {
			this.product_lines = r;

			const selected = [];
			this.product_lines.forEach(a => {
				selected.push(a.line_field)
			});
			this.reportForm.get('lines').setValue(selected)
		});

	}

	getItemHistory(pitem: any) {
		this.purchitem = pitem;

		this.inventoryService.getItem({ stockid: pitem.stockid }).subscribe((item: any) => {
			this.item = item;
			this.inventoryService.getHistory(pitem.stockid).subscribe((results: any) => {
				this.itemhistory = results;
				this.modalService.open(this.itemhistoryele, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

				}, (reason) => {
					this.itemhistory = {};
				});

			})
		})
	}

	updateChecks(event: any, filter_id: any) {

		if (!this.selected_checks[filter_id]) {
			this.selected_checks[filter_id] = [];
		}

		const data = { value: event.source.value };

		if (event.checked) {
			this.selected_checks[filter_id].push(data)
		} else {

			const index = this.selected_checks[filter_id].indexOf(data);

			this.selected_checks[filter_id] = this.selected_checks[filter_id].filter((selected, index) => {
				return selected.value != event.source.value
			});
		}
		//prevent empty send
		if (this.selected_checks[filter_id].length) {
			this.selected_filters[filter_id] = { filter_id: filter_id, value: this.selected_checks[filter_id] };
		} else {
			this.selected_filters[filter_id] = {};
		}
	}

	createBatchBo() {
		this.flip = (this.flip == 'inactive') ? 'active' : 'inactive';
	}

	creteMultiplePos() {

	}

	updateSearchSelect(event: any, filter_id: any) {
		this.selected_filters[filter_id] = { filter_id: filter_id, value: event.value };
	}

	updateSearchSelectMulti(event: any, filter_id: any) {
		//event.value.valueforEach(val => {
		this.selected_filters[filter_id] = { filter_id: filter_id, value: event.value };

		//})
	}

	editBin(item: any) {
		item.editing = (item.editing) ? false : true;
	}

	parsePurchaseQty(v: any): number {
		if (v === null || v === undefined || v === '') {
			return 0;
		}
		const n = parseFloat(String(v).replace(/,/g, ''));
		return isNaN(n) ? 0 : n;
	}

	/** Shown on Results → primary review & verify steps (excludes negatives handled via RMA / exclude prompt). */
	showInPurchaseReview(item: any): boolean {
		return !item._hideFromPurchaseReview;
	}

	get rmaReviewVendorKeys(): string[] {
		return Object.keys(this.rmaReviewByVendor || {}).filter((k) => (this.rmaReviewByVendor[k] || []).length > 0);
	}

	private collectUnhandledNegativePurchaseLines(): { vendor: string; line: any }[] {
		const out: { vendor: string; line: any }[] = [];
		if (!this.po_vendors_found || !this.results) {
			return out;
		}
		for (const vendor of this.po_vendors_found) {
			const rows = this.results[vendor];
			if (!rows) {
				continue;
			}
			for (const line of rows) {
				if (line._hideFromPurchaseReview) {
					continue;
				}
				if (this.parsePurchaseQty(line.qty_purchase) < 0) {
					out.push({ vendor, line });
				}
			}
		}
		return out;
	}

	private applyNegativePurchaseExclude(hits: { vendor: string; line: any }[]) {
		for (const { line } of hits) {
			line.qty_purchase = 0;
			line.orderqty = 0;
			line._hideFromPurchaseReview = true;
		}
	}

	private applyNegativePurchaseToRmaReview(hits: { vendor: string; line: any }[]) {
		for (const { vendor, line } of hits) {
			if (!this.rmaReviewByVendor[vendor]) {
				this.rmaReviewByVendor[vendor] = [];
			}
			const q = this.parsePurchaseQty(line.qty_purchase);
			this.rmaReviewByVendor[vendor].push({
				stockid: line.stockid,
				description: line.description,
				brand_data: line.brand_data,
				vendorKey: vendor,
				rma_return_qty: Math.abs(q),
				original_recommendation: q,
				target_purchase: line.target_purchase,
				selected_option: line.selected_option,
			});
			line.qty_purchase = 0;
			line.orderqty = 0;
			line._hideFromPurchaseReview = true;
		}
	}

	/**
	 * When opening the Results tab: negative recommended purchase qty must be RMA-handled or excluded — not PO review.
	 */
	onReorderMainTabChange(ev: MatTabChangeEvent) {
		if (ev.index !== 1) {
			return;
		}
		const hits = this.collectUnhandledNegativePurchaseLines();
		if (!hits.length) {
			return;
		}
		const n = hits.length;
		const msg =
			`${n} line(s) have a negative recommended purchase quantity (suggesting a return or stocking reduction).\n\n` +
			`OK — Move these lines to the RMA review tab and remove them from purchase order review.\n` +
			`Cancel — Exclude from purchase review only (purchase qty set to 0; not added to RMA list).`;
		if (confirm(msg)) {
			this.applyNegativePurchaseToRmaReview(hits);
		} else {
			this.applyNegativePurchaseExclude(hits);
		}
	}

	updateQuantity(event: any, item: any) {
		const raw = event && event.target ? event.target.value : event;
		const n = this.parsePurchaseQty(raw);

		this.po_vendors.forEach((po: any) => {
			const poline = po.lines.filter(a => {
				return a.stockid == item.stockid;
			})[0]
			if (poline) {
				poline.orderqty = n;
			}
		})

		item.qty_purchase = n;
		item.orderqty = n;
		if (n < 0) {
			item._hideFromPurchaseReview = false;
		} else if (n > 0) {
			item._hideFromPurchaseReview = false;
		}
	}

	updatePrice(event: any, item: any) {
		item.price = event;
		this.reduceItems();
	}


	updateBinItem(event: any, item: any) {
		const index = this.results.indexOf(item);
		item.bin = event;
		item.editing = false;
	}

	setPurchOrderOptions(item: any, pdata: any) {
		item.selected_option = pdata;
		this.modalService.dismissAll();
	}

	viewPurchData(item: any) {
		this.purchase_item = item;


		this.modalService.open(this.purchasedetails, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

		}, (reason) => {
			this.purchase_item = {};
		});
	}

	getHtmlTable() {
		let html = '<table class="table table-fixed table-hover table-bordered sticky-header"><thead><tr>';
		html += `
		  <th>Brand</th>
		  <th>ProductLine</th>
		  <th class="td-item">Item#</th>
		  <th class="td-max">Description</th>
		  <th class="text-center">QOH</th>
		  <th class="text-center">QOS</th>
		  <th class="text-center">QOO</th>
		  <th class="text-center">Total Period Sales</th>
		  <th class="text-center">Days Closed</th>
		  <th class="text-center">No Stock Days</th>
		  <th class="text-center">Sellable Days</th>
		  <th class="text-center">Day Supply</th>
		  <th class="text-center">Daily Turn</th>
		  <th class="text-center">Price</th>
		  <th class="text-center">Purchase</th>
		</tr></thead><tbody>`;

		this.po_vendors_found.forEach(vendor => {
			this.results[vendor].forEach(item => {
				html += `<tr>
			  <td><b>${item.brand_data.brand}</b></td>
			  <td>${item.brand_data.lineid}-${item.brand_data.linedesc}</td>
			  <td class="td-item">${item.stockid}</td>
			  <td>${item.description}</td>
			  <td class="text-center">${item.qoh}</td>
			  <td class="text-center">${item.qos}</td>
			  <td class="text-center">${item.qop}</td>
			  <td class="text-center border-left border-right">${item.rolling_total}</td>
			  <td class="text-center border-left border-right">${item.nosales}</td>
			  <td class="text-center">${item.outofstock}</td>
			  <td class="text-center">${item.day_c}</td>
			  <td class="text-center">${Number(item.days_supply).toFixed(2)}</td>
			  <td class="text-center">${Number(item.avg_day).toFixed(2)}</td>
			  <td class="text-center">$${Number(item.selected_option.price).toFixed(2)}</td>
			  <td class="text-center">${Number(item.target_avg_day).toFixed(0)}</td>
			</tr>`;
			});
		});
		html += '</tbody></table>';
		return html;
	}

	exportXls() {
		const encoded: string = this.globalSearchService.base64encode(this.getHtmlTable());
		const filterStr = this.getFilterString();
		const data = {
			content: encoded,
			filename: 'DailyTurnsReorder',
			title: 'Daily Turns Re-Order',
			subtitle: filterStr ? filterStr + ' | Created ' + new Date().toLocaleString() : 'Created ' + new Date().toLocaleString(),
		}
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	removePoItem(line: any, po: any, item: any) {
		const poindex = this.po_vendors.indexOf(po);
		const lineindex = this.po_vendors[poindex].lines.indexOf(line);
		this.po_vendors[poindex].lines.splice(lineindex, 1);
		const index = this.results.indexOf(item);
		this.results.splice(index, 1);
	}

	removeItem(item: any, vendor?: string) {
		if (vendor && this.results && this.results[vendor]) {
			const index = this.results[vendor].indexOf(item);
			if (index >= 0) {
				this.results[vendor].splice(index, 1);
			}
			return;
		}
		const index = this.results.indexOf(item);
		if (index >= 0) {
			this.results.splice(index, 1);
		}
	}

	reduceItems() {

		this.foundvendors = this.allresults.vendors
		this.months = this.allresults.months
		this.futuremonths = this.allresults.future_months
		const poitems = [];
		this.allresults.data.forEach((item: any) => {

			const already_ordered = 0;
			const qty = item.qty_purchase;

			item.vendor = item.selected_option.supplierno;
			item.price = parseFloat(item.selected_option.price);
			const data = {
				vendor: item.selected_option.supplierno,
				vendor_name: item.selected_option.suppname,
				stockid: item.stockid,
				description: item.description,
				orderqty: qty,
				price: parseFloat(item.selected_option.price),
				options_selected: item.selected_option,
				purchdata: item.purchdata,
				item: item,
			}
			poitems.push(data);

		});

		const all_vendors = poitems.map(a => a.vendor);
		const unique_vendors = all_vendors.filter((x, i, a) => a.indexOf(x) == i)
		this.purchase_items = poitems;
		if (poitems.length) {
			const data = { poitems: poitems }
			this.loading_remote = true;
			this.purchasingService.getRemoteQty(data).subscribe((results: any) => {
				this.allresults = results;
				this.loading_remote = false;
				//map data down: broken down by vendor
				//this.reduceItems();
			});
		}
	}

	formSubmitAttempted = false;

	getRequiredErrors(): string[] {
		if (!this.reportForm) return [];
		const names: Record<string, string> = {
			loccode: 'Warehouse',
			supplier: 'Vendor',
			brands: 'Brands',
			startdate: 'Start date',
			enddate: 'End date',
			days_supply: 'Day supply'
		};
		return Object.keys(names).filter(key => {
			const c = this.reportForm.get(key);
			return c && c.invalid && c.errors && c.errors['required'];
		}).map(key => names[key]);
	}

	getRecomendations() {
		this.formSubmitAttempted = true;
		if (!this.reportForm.valid) {
			this.reportForm.markAllAsTouched();
			this.globalSearchService.showNotification('Please complete all required fields.', 'warn', 'bottom', 'right');
			return;
		}
		this.indexnow = 1;

		this.reviewlabel = 'Review Primary Recommendations'
		this.reportForm.get('filters').setValue(this.selected_filters);
		this.loading = true;

		if (this.retriving) {
			this.retriving.unsubscribe();
		}

		const formVal = this.reportForm.value;
		const payload: any = { ...formVal };
		delete payload.sku_list_text;
		const stockids = this.parseSkuListFromText(formVal.sku_list_text);
		if (stockids.length > 5000) {
			this.globalSearchService.showNotification('SKU list limited to 5000 items (extra rows ignored).', 'warn', 'bottom', 'right');
		}
		if (stockids.length > 0) {
			payload.stockids = stockids.slice(0, 5000);
		}

		this.retriving = this.purchasingService.getDailyRecomendations(payload).subscribe((results: any) => {

			this.loading = false;
			this.allresults = results;
			this.rolling_months = results.rolling_months
			this.results = results.data;
			this.allitems = results.data;
			this.months = results.months;
			this.futuremonths = results.future_months;
			this.po_vendors_found = results.vendors;
			this.watch_items = results.watch_items;
			this.retriving = false;
			this.rmaReviewByVendor = {};

			this.updateTargetsPullover()
		});
	}


	submitPo(po: any) {

		const proceed = confirm('You are about to create a purchase order. Continue?');

		if (proceed) {

			this.sending = true;
			const vendor = this.suppliers.filter((s: any) => {
				const findindex = s.supplierid + ': ' + s.suppname;
				return po == findindex
			})[0];

			const remove_vendor = po;

			vendor.loccode = this.reportForm.get('loccode').value;
			vendor.lines = this.results[po].filter((i: any) => this.parsePurchaseQty(i.qty_purchase) > 0);

			if (vendor.lines.length) {
				const data = [
					{ vendor: vendor }
				]

				this.purchasingService.createPurchaseOrdersFromRecomend(data).subscribe((result: any) => {
					this.sending = false;
					this.poCreateError = '';
					if (result.success) {
						this.lastCreatedPos = Array.isArray(result.created) ? result.created : [];
						this.globalSearchService.showNotification(result.message, 'success', 'bottom', 'right');
						this.indexnow++;

						switch (this.indexnow) {
						case 2:
							this.reviewlabel = 'Review Secondary Recommendations'
							break;
						case 3:
							this.reviewlabel = 'Review Tertiary Recommendations'
							break;
						}
						const newresults = this.results[po].filter((ro: any) => {
							return ((ro.qty_purchase <= ro.target_purchase) && ro.purchdata.length);
						});

						const watchlist = this.results[po].filter((ro: any) => {
							return ((ro.qty_purchase > ro.target_purchase) && ro.purchdata.length);
						});

						const next_set = [];
						const suppindex = '';
						this.results = [];


						newresults.forEach((i: any, index) => {
							//secondary supplier?
							const newpdata = i.purchdata.filter((p: any) => {
								return parseInt(p.preferred_sort) == this.indexnow;
							})[0]

							if (newpdata) {
								const suppindex = newpdata.supplierno + ': ' + newpdata.suppname;
								const thisalreadythere = this.po_vendors_found.indexOf(suppindex);

								if (thisalreadythere < 0) {
									this.po_vendors_found.push(suppindex)
								}

								i.vendor = suppindex
								i.selected_option = newpdata
								i.qty_purchase = i.target_purchase - i.qty_purchase;
								i.total_available = newpdata.total_available

								if (newpdata.total_available < i.qty_purchase) {
									i.qty_purchase = newpdata.total_available;
								}

								if (!this.results[suppindex]) {
									this.results[suppindex] = [];
								}

								this.results[suppindex].push(i)

							} else {

							}
						});

						watchlist.forEach((i: any, index) => {
							this.wathchlist.push(i)
						});


						const remove = this.po_vendors_found.indexOf(po)
						this.po_vendors_found.splice(remove, 1)

						if (this.po_vendors_found.length) {
							this.currentstep = 0;
						}
						this.sending = false;
					} else {
						this.lastCreatedPos = [];
						this.poCreateError = result.message || 'Purchase order could not be created.';
						this.globalSearchService.showNotification(this.poCreateError, 'danger', 'bottom', 'right');
						this.sending = false;
					}
				}, (err) => {
					this.sending = false;
					this.lastCreatedPos = [];
					this.poCreateError = err?.error?.message || err?.message || 'Request failed.';
					this.globalSearchService.showNotification(this.poCreateError, 'danger', 'bottom', 'right');
				});
			} else {
				this.sending = false;
			}
		}
	}

	dismissPoSuccess(): void {
		this.lastCreatedPos = [];
	}

	dismissPoError(): void {
		this.poCreateError = '';
	}

	vendorHasFillable(po: any) {
		const openlines = this.results[po].filter((line: any) => {
			return this.parsePurchaseQty(line.qty_purchase) > 0
		})
		return (openlines.length) ? true : false;
	}
	printResults(po: any) {

		const vendor = this.suppliers.filter((s: any) => {
			const findindex = s.supplierid + ': ' + s.suppname;
			return po == findindex
		})[0];

		vendor.loccode = this.reportForm.get('loccode').value;
		vendor.lines = (this.results[po] || []).filter((line: any) => this.parsePurchaseQty(line.qty_purchase) > 0);

		const data = vendor

		this.purchasingService.printPreviewPo(data).subscribe((results: any) => {
			this.goToLink(results.url);
		});
	}

	goToLink(url: string) {
		window.open(url, '_blank');
	}

	discontinueItems() {


		const proceed = confirm('Discontinue ' + this.watch_items.length + ' Items?')
		if (proceed) {
			this.purchasingService.discontinueItems(this.watch_items).subscribe((result: any) => {
				this.watch_items = this.watch_items.filter((r: any) => {
					return (!r.watchlist);
				});
			});
		}

	}

	dateChanged() {
		this.numberofdays = this.datediff(new Date(this.reportForm.get('enddate').value), new Date(this.reportForm.get('startdate').value));
	}

	ngAfterViewInit() {
		this.globalSearchService.locations.subscribe((results: any) => {
			this.locations = results || [];
			if (this.locations.length && this.reportForm) {
				const loccodeCtrl = this.reportForm.get('loccode');
				const current = loccodeCtrl?.value;
				const valid = this.locations.some((l: any) => l.loccode === current);
				if (!valid) {
					loccodeCtrl?.setValue(this.locations[0].loccode);
				}
			}
		});
	}

}
